import { Divider, Typography } from "antd";
import React from "react";
// import CajaForm from "./CajaForm";
import CajaList from "./CajaList";
import "./CajaStyles.css";

const { Title } = Typography;

const CajaManagement = () => {
    // const [refreshKey, setRefreshKey] = useState(0);
    // const [selectedCaja, setSelectedCaja] = useState(null);
    const isMobile = window.innerWidth < 768;

    // // Esta función se ejecutará cuando se agregue una nueva caja
    // const handleCajaAdded = () => {
    //     // Incrementar el key para forzar la actualización de la lista de cajas
    //     setRefreshKey((prevKey) => prevKey + 1);
    // };

    // Esta función se ejecutará cuando se edite una caja
    // const handleCajaEdited = (caja) => {
    //     setSelectedCaja(caja);
    // };

    // // Esta función se ejecutará cuando se actualice una caja
    // const handleCajaUpdated = () => {
    //     // Limpiar la caja seleccionada e incrementar el key para actualizar la lista
    //     setSelectedCaja(null);
    //     setRefreshKey((prevKey) => prevKey + 1);
    // };

    return (
        <div className="caja-management-container">
            <Title level={2}>{isMobile ? "Cajas" : "Gestión de Cajas"}</Title>
            <Divider />

            {/* <Row gutter={[24, 24]}> */}
            {/* <Col xs={24} lg={12}>
                    <Card>
                        <CajaForm
                            onCajaAdded={handleCajaAdded}
                            onCajaUpdated={handleCajaUpdated}
                            cajaToEdit={selectedCaja}
                        />
                    </Card>
                </Col> */}

            {/* <Col xs={24} lg={12}> */}
            <CajaList
            // refreshTrigger={refreshKey}
            // onEditCaja={handleCajaEdited}
            />
            {/* </Col> */}
            {/* </Row> */}
        </div>
    );
};

export default CajaManagement; 